import { render, staticRenderFns } from "./InvitationResponseButtons.vue?vue&type=template&id=3d6fb713&scoped=true&"
import script from "./InvitationResponseButtons.vue?vue&type=script&lang=js&"
export * from "./InvitationResponseButtons.vue?vue&type=script&lang=js&"
import style0 from "./InvitationResponseButtons.vue?vue&type=style&index=0&id=3d6fb713&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6fb713",
  null
  
)

export default component.exports